import { createFileRoute } from '@tanstack/react-router'
import { Zalo } from '@/components/settings-route/multi-channel/zalo/index.jsx'

export const Route = createFileRoute('/_auth/settings/multi-channels/zalo')({
  component: Zalo,
})
